import AdvancedCreateModal from 'components/CIMSModal/AdvancedCreateModal'
import { useAsphaltMixDesignsContext } from '../../AsphaltMixDesignsContext'
import { useCreateAsphaltMixDesignMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { DetailsValues } from '../Details/types'
import Details from '../Details'
import AdditionalInfo from '../AdditionalInfo'
import { AdditionalInfoValues, Percentage } from '../AdditionalInfo/types'
import { useProjectCustomFieldsContext } from 'components/CustomFields/ProjectCustomFieldsContext'
import { errorHandler } from 'hooks/errorHandler'
import { useProjectContext } from 'context/ProjectContext'

const CreateModal: React.VFC = () => {
  const { projectId } = useProjectContext()
  const {
    createModal: { toggle, visible },
    refetch,
    metadata,
  } = useAsphaltMixDesignsContext()
  const [create] = useCreateAsphaltMixDesignMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createAsphaltMixDesign: {
        mixDesign: { mixDesignNumber, globalId },
      },
    }) => simpleCreateNotification(mixDesignNumber ?? globalId),
  })
  const { toMutateCustomFieldsInput } = useProjectCustomFieldsContext()
  return (
    <AdvancedCreateModal
      initialFormValues={{
        percentages: metadata.targets.reduce(
          (percentages, { id: targetId, name, required }) => {
            if (required) percentages.push({ targetId, name, percentage: null })
            return percentages
          },
          Array<Percentage>()
        ),
      }}
      onClose={() => toggle(null)}
      visible={visible}
      details={<Details />}
      additionalInfo={<AdditionalInfo />}
      attachments={false}
      ok={{
        fn: async (store) => {
          if (!projectId) return errorHandler('Project id must be defined')

          const {
            percentages,
            customFields,
            expirationDate,
            materialSource,
            designBinderContent,
            grade,
            mixDesignNumber,
            nominalSize,
            supplier,
            theoMaxSpecGrav,
            vma,
            ...values
          } = store as DetailsValues & AdditionalInfoValues
          await create({
            variables: {
              input: {
                ...values,
                // Required field so using bang
                vma: vma!,
                // Required field so using bang
                theoMaxSpecGrav: theoMaxSpecGrav!,
                // Required field so using bang
                supplier: supplier!,
                // Required field so using bang
                nominalSize: nominalSize!,
                // Required field so using bang
                mixDesignNumber: mixDesignNumber!,
                // Required field so using bang
                grade: grade!,
                // Required field so using bang
                designBinderContent: designBinderContent!,
                // Required field so using bang
                expirationDate: expirationDate!.toISOString(),
                materialSourceId: materialSource?.value as string,
                projectId,
                customFields: toMutateCustomFieldsInput(customFields),
                percentages: percentages?.map(({ targetId, percentage }) => ({
                  targetId,
                  // Required field so using bang
                  percentage: percentage!,
                })),
              },
            },
          })
          refetch()
        },
      }}
    />
  )
}

export default CreateModal
